import { useNavigate } from 'react-router-dom';

export const useLandingPage = () => {
  const navigate = useNavigate();

  const handleRedirect =
    ({ target }: { target: string }) =>
    () => {
      navigate(target);
    };

  return {
    handleRedirect,
  };
};
